"use client";

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Flex,
  Box,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import { LockIcon, StarIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";


export default function PremiumFeatureModal({ isOpen, onClose,message }) {
  
    const navigate = useNavigate();
  const bgGradient = useColorModeValue(
    "linear(to-b, purple.50, white)",
    "linear(to-b, purple.900, gray.800)"
  );

  const handleUpgrade = () => {
    onClose();
  
    // Delay navigation by 500 milliseconds (adjust as needed)
    setTimeout(() => {
      navigate("/influencer/profile?tab=membership");
    }, 500);
  };
  

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="md">
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(5px)" />
      <ModalContent borderRadius="xl" overflow="hidden">
        <Box bgGradient={bgGradient} py={6} px={4} position="relative">
          <Flex
            position="absolute"
            top={-2}
            right={-2}
            bg="purple.500"
            borderRadius="full"
            p={3}
            boxShadow="lg"
          >
            <Icon as={LockIcon} w={6} h={6} color="white" />
          </Flex>
          <ModalHeader
            textAlign="center"
            fontSize="2xl"
            fontWeight="bold"
            pb={0}
          >
            Premium Feature
          </ModalHeader>
          <ModalBody textAlign="center" pt={2}>
            <Flex justify="center" mb={4}>
              {[...Array(3)].map((_, i) => (
                <Icon
                  key={i}
                  as={StarIcon}
                  w={6}
                  h={6}
                  color="yellow.400"
                  mx={1}
                  transform={`rotate(${i * 5}deg)`}
                />
              ))}
            </Flex>
            <Text fontSize="lg" mb={3}>
            {message} 
            </Text>
           
          </ModalBody>
        </Box>

        <ModalFooter bg="white" flexDirection="column" p={6}>
          <Button
            colorScheme="purple"
            size="lg"
            width="full"
            mb={3}
            onClick={handleUpgrade}
            fontWeight="bold"
            boxShadow="md"
            _hover={{ transform: "translateY(-2px)", boxShadow: "lg" }}
            transition="all 0.2s"
          >
            Upgrade Now
          </Button>
          <Button variant="ghost" onClick={onClose} size="md">
            Maybe Later
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
